/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Search_All_FilesInputs */



/**
* | output |
* | --- |
* | "Find something in my files" |
*
* @param {Uno_Welcome_Suggestion_Search_All_FilesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_search_all_files = /** @type {((inputs?: Uno_Welcome_Suggestion_Search_All_FilesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Search_All_FilesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Etwas in meinen Dateien finden")
	return /** @type {LocalizedString} */ ("Find something in my files")
});